export type ImageStyle = 'realistic' | 'illustration' | 'minimalist' | '3d' | 'corporate' | 'creative';
export type ImageSource = 'ai_generated' | 'uploaded' | 'background_removed' | 'edited';
export type ImageStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface ImageSize {
  label: string;
  value: string;
  width: number;
  height: number;
}

export interface GeneratedImage {
  id: string;
  user_id: string;
  project_id?: string;
  campaign_id?: string;
  title?: string;
  prompt?: string;
  style?: ImageStyle;
  original_url?: string;
  edited_url?: string;
  thumbnail_url?: string;
  s3_key?: string;
  width?: number;
  height?: number;
  file_size?: number;
  mime_type?: string;
  source: ImageSource;
  metadata?: Record<string, any>;
  tags?: string[];
  is_favorite: boolean;
  status: ImageStatus;
  error_message?: string;
  parent_image_id?: string;
  campaign?: { id: string; name: string };
  versions?: GeneratedImage[];
  created_at: string;
  updated_at: string;
}

export interface ImageGenerateParams {
  prompt: string;
  style?: ImageStyle;
  size?: string;
  title?: string;
  campaign_id?: string;
  async?: boolean;
  reference_image_url?: string;
}

export interface ImageFilters {
  page?: number;
  limit?: number;
  source?: ImageSource;
  search?: string;
  campaign_id?: string;
  // 'none' = imagens sem pasta. UUID = pasta específica. undefined = todas.
  folder_id?: string | 'none';
  is_favorite?: string;
  status?: ImageStatus;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export interface ImageUsageStats {
  totalImages: number;
  monthlyGenerations: number;
  favoriteCount: number;
}

export interface ImageEditorState {
  tool: 'select' | 'crop' | 'text' | 'draw' | 'shape' | 'filter';
  zoom: number;
  canUndo: boolean;
  canRedo: boolean;
}

export const IMAGE_STYLES: { value: ImageStyle; label: string; description: string }[] = [
  { value: 'realistic', label: 'Realistic', description: 'Photorealistic, professional photography' },
  { value: 'illustration', label: 'Illustration', description: 'Digital illustration, artistic' },
  { value: 'minimalist', label: 'Minimalist', description: 'Clean, simple, modern design' },
  { value: '3d', label: '3D Render', description: '3D volumetric lighting render' },
  { value: 'corporate', label: 'Corporate', description: 'Professional business style' },
  { value: 'creative', label: 'Creative', description: 'Artistic, vibrant, eye-catching' }
];

export const IMAGE_SIZES: ImageSize[] = [
  { label: 'Square (1:1)', value: '1024x1024', width: 1024, height: 1024 },
  { label: 'Portrait (2:3)', value: '1024x1536', width: 1024, height: 1536 },
  { label: 'Landscape (3:2)', value: '1536x1024', width: 1536, height: 1024 }
];
